<script>
/**
 * @overview 课时管理 - 列表单项
 *
 * @author huojinzhao
 */

export default {
  name: "CourseListItem",

  props: {
    data: {
      type: Object,
      required: true,
    },
    // 复制权限
    isFuzhiPermissions: {
      type: Boolean,
      default: false,
    },
    // 移动权限
    isMovePermissions: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classStatus() {
      const statusMap = [
        "",
        "state-relievo-warning",
        "state-relievo-primary",
        "state-relievo-success",
      ];

      return statusMap[this.data.course_status];
    },
  },
};
</script>

<template>
  <AppMasker
    :style="{'background': `url('${data.image}') no-repeat center center`,
             'background-size': 'auto 100%'}"
    :is-fuzhi-permissions="isFuzhiPermissions"
    :is-move-permissions="isMovePermissions"
    types="edit,preview,delete,fuzhi"
    class="course-list-item"
    width="240px"
    radius
    @edit="$emit('update', data)"
    @preview="$emit('preview', data.id,data.structure_id)"
    @delete="$emit('delete', data.id)"
    @fuzhi="$emit('fuzhi', data)"
  >
    <ul class="no-finish">
      <li v-show="data.preview_status_name =='未完成'">预习未完成</li>
      <li v-show="data.lesson_preparation_status_name =='未完成'">备课未完成</li>
      <li v-show="data.review_status_name =='未完成'">复习未完成</li>
    </ul>
    <span :class="`course-list-item__status ${classStatus}`">
      {{ data.course_status_name }}
    </span>

    <ol class="module-list-item-label">
      <li class="layout-ellipsis">
        {{ `${data.name} ${data.title}` }}
      </li>
    </ol>
  </AppMasker>
</template>

<style lang="postcss">
.course-list-item {
  display: flex;
  flex-direction: column;
  position: relative;
}
.no-finish{
  position: absolute;
  right: 10px;
  font-size: 14px;
  line-height: 24px;
  top: 60px;
  color: #ff0000;
}

.course-list-item__status {
  //flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 32px;
}

.course-list-item .module-list-item-label {
  margin-top: auto
}
</style>
